<script setup lang="ts">
import { Expand } from '@/shared/icons'
import { useViewport } from '@/shared/lib'
import { Icon } from '@/shared/ui/Icon'
import { Inline } from '@/shared/ui/Inline'

import { useSidebarStore } from '../model/sidebar'
import RouteBreadcrumb from './RouteBreadcrumb.vue'

const sidebar = useSidebarStore()
const { isMobile } = useViewport()
</script>

<template>
  <div class="navbar">
    <Inline align="center">
      <div
        id="hamburger-container"
        class="navbar__hamburger"
        :class="{ 'navbar__hamburger--active': sidebar.opened }"
        @click="sidebar.toggle()"
      >
        <Icon><Expand /></Icon>
      </div>
      <RouteBreadcrumb
        v-if="!isMobile"
        id="breadcrumb-container"
        class="breadcrumb-container"
      />
    </Inline>
    <slot name="right-menu" />
  </div>
</template>

<style lang="scss" scoped>
.navbar {
  display: flex;
  justify-content: space-between;
  height: 50px;
  overflow: hidden;
  // `position: sticky` stops working the moment an ancestor takes an `overflow` other
  // than `visible` — `.main-container` and `.app-wrapper` have to stay as they are.
  position: sticky;
  top: 0;
  z-index: 10;
  background: var(--el-bg-color);
  box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);
}

.navbar__hamburger {
  display: flex;
  align-items: center;
  height: 100%;
  padding: 0 15px;
  cursor: pointer;
  transition: background 0.3s;
  -webkit-tap-highlight-color: transparent;

  &:hover {
    background: rgba(0, 0, 0, 0.025);
  }
}

.navbar__hamburger--active {
  transform: rotate(180deg);
}
</style>
